import {Component} from "react"
import {Button, Form, Modal} from "react-bootstrap"
import {toast} from "react-toastify"
import { Subscription } from "rxjs"
import { APIError } from "../../api/ObservableFromFetch"
import UserPasswordReset from "../../api/Administration/UserPasswordReset"
import { EmailRegexp } from "../../config/Constants"

interface ForgotPasswordProps{
  userName?: string
}

interface ForgotPasswordState {
  showModal: boolean
  userName: string
  userNameValid: boolean
}

export default class ForgotPassword extends Component<ForgotPasswordProps, ForgotPasswordState> {
  state: ForgotPasswordState = {
    showModal: false,
    userName: "",
    userNameValid: false
  }

  userPasswordResetSubscription?: Subscription

  componentWillUnmount() {
    this.userPasswordResetSubscription && this.userPasswordResetSubscription.unsubscribe()
  }

  isEmailValid = (value: string) => value.length > 0 && EmailRegexp.test(value)
  handleShow = () => this.setState({showModal: true, userName: this.props.userName || '', userNameValid: this.isEmailValid(this.props.userName || "")})
  handleClose = () => this.setState({showModal: false})
  handleChange = (email: string) => this.setState({userName: email, userNameValid: this.isEmailValid(email)})

  submitPasswordReset = () => {
    this.userPasswordResetSubscription && this.userPasswordResetSubscription.unsubscribe()

    this.userPasswordResetSubscription = UserPasswordReset(this.state.userName, window.location.href, true).subscribe(
      data => {
        toast.success(data)
        this.handleClose()
      },
      (error) => this.handleAPIError(error, {})
    )
  }

  handleAPIError = (error: Error | APIError, stateChanges: object) => {
    this.setState(stateChanges)
    error && toast.error((error as APIError)?.errorData?.message || error.message)
  }

  render() {
    const { userName, userNameValid } = this.state

    return <>
        <Button variant="link" onClick={()=> {this.handleShow()}}>Forgot Password</Button>
        <Modal show={this.state.showModal} onHide={()=> {this.handleClose()}}>
          <Modal.Header closeButton>
            <Modal.Title>Forgot Password</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Please enter your email address:</Form.Label>
                  <Form.Control value={userName} type="text" placeholder="Enter email" onChange={(e) => this.handleChange(e.target.value)} isInvalid={!userNameValid} />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleClose}>Close</Button>
            <Button variant="primary" onClick={this.submitPasswordReset} disabled={!userNameValid} >Email Password Reset Link</Button>
          </Modal.Footer>
        </Modal>
    </>
  }
}